import { Navigate } from "react-router-dom";
import { useMe } from "@/api/hooks";

// IndexRedirect: routes the "/" index URL to the right landing page
// based on the user's role. Operators+ get the dashboard; auditors and
// anonymous visitors get the receipts viewer.
export function IndexRedirect() {
  const me = useMe();
  // While /me is in flight, show nothing (avoids a flash of /receipts
  // for a user that's about to be redirected to /dashboard).
  if (me.isLoading) return null;
  if (me.data && (me.data.role === "operator" || me.data.role === "admin")) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Navigate to="/receipts" replace />;
}
